import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { DialogContentCustom, DialogTitleCustom } from './DialogCustomModule';

export const CommonDialogBox = (props) => {
   const { dialog, handleClick, customProps } = props;

   return (
      <Dialog {...customProps}>
         <DialogTitleCustom title={dialog.title} type={dialog.type} onClose={customProps.onClose} />
         <DialogContent className="custom-modal-content" sx={{ '&.custom-modal-content': { p: 2 } }}>
            {props.children}
         </DialogContent>
         {dialog.actionButtonVisible && (
            <DialogActions sx={{ justifyContent: 'center' }} className="custom-modal-footer">
               {dialog.createButtons.map((item, i) => (
                  item.btnVisible && <Button keys={`button_${i}`} disabled={item.disabled} onClick={(item.btnFun == 'cancel' && customProps.onClose) || (item.btnFun == 'confirm' && handleClick)} variant={item.variant} sx={{ boxShadow: 'none', borderRadius: '17px', textTransform: 'capitalize' }}>{item.btnText}</Button>
               ))}
            </DialogActions>
         )}
      </Dialog>
   );
}
